import '../../../styles/Home/header.scss';

const Header = () => {

  return (
    <section id="header" className="header">

      <div className="header__container">
        <div className="header__container--left">
          <div className="header__heading">
            <h1 className="header__heading--main" >
              DevHack
            </h1>
          </div>
          <div className='header__slogan'>
            <span>Join</span>
            <span>Learn</span>
            <span>Build</span>
            <span className='header__slogan--date'>24 & 25 May</span>
          </div>
          <div>
            <p className="header__text">
              COMSATS Sahiwal is hosting a hackathon for participants from all over Pakistan, with cash prizes for top teams. The event will bring together coders,
              developers, and entrepreneurs to work on innovative projects. It will be held over a period of 48 hours and accommodation and mentorship will be provided.
              Registration is open for all students, professionals, and enthusiasts.
            </p>
            <a href="https://forms.gle/cNNW69tXxZy9UK1S8" className="header__button" target={'_blank'} data-cursor-enlarge="true" rel="noreferrer" >Register</a>
            <a href="https://discord.gg/7qk7Beu3aP" className="header__discord" target={'_blank'} data-cursor-enlarge="true" rel="noreferrer" >Join Discord</a>
          </div>
        </div>

        <div className="header__container--right">
          <div className='header__box'>
            <img src='./images/networkGlobe.gif' alt='Network Globe' />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Header;